import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string, allowing safe tags/attributes only.
 * Blocks: scripts, event handlers (onerror, onclick, etc.), iframes, javascript: URIs.
 * Preserves: links, images, basic formatting, tables, divs, spans, inline styles.
 */
export const sanitizeHTML = (html) => {
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ['img'],
    ADD_ATTR: ['target', 'rel', 'style'],
  });
};
